import{observer,ComponentView,Preact,h,state,action,Router,Link,Cls,m,Keyframes,Media} from "@websites/website_compiler/Client";
import {AEComponentView} from "../../stores/ui";
import * as C from "../../components/BaseCss";
import * as Icons from "../../components/Icons";
import * as Sidepanel from "../../components/Sidepanel";
import * as Options from "../../components/Options"
import {Footer, VerticalSpacer, PageMargins,SolidBtn,PageTitle,Header,HeaderLeft,HeaderCenter,HeaderRight,Spinner,App,FacebookIcon,InstagramIcon} from "../../components/Misc";
import { CompanyData } from "../../misc";
import * as Css from "./contactCss";


export class Props{
}

@observer export class Page extends AEComponentView<Props>{
    @state name : string;
    @state email : string;
    @state phone : string;
    @state message : string;

    @state nameError : string;
    @state emailError : string;
    @state phoneError : string;
    @state messageError : string;
    @state sending = false;
    @state errorMessage : string;
    @state successMessage : string;

    @action onChange(){
        this.errorMessage = null;
        this.successMessage =null;
    }
    @action submit = async (event) => {
        event.preventDefault();
        console.log("submit",event);

        if(this.sending){
            return;
        }
        this.sending = true;

        // if(!this.name){
        //     this.nameError = "Name is required";
        // }
        // if(this.nameError){
        //     return false;
        // }

        var obj = {
            name:this.name,
            eml:this.email,
            phone:this.phone,
            message:this.message,
            eml2:""
        }

        var resp = await fetch("/api/contact",{
            method:"POST",
            body: JSON.stringify(obj),
            credentials: 'include',
            headers:{"Content-type":"application/json"},
        });

        console.log("post resp",resp);
        this.sending = false;
        this.email = "";
        this.name = "";
        this.phone = "";
        this.message = "";
        
        if(!resp.ok){
            this.errorMessage = "Unkown Error"
            return;
        }

        this.successMessage = "Successfully sent message, check your inbox for confirmation email";

        console.log("success");

        var json = await resp.json();

        console.log("post json",json);
        

    }
    @action onNameChange =(event)=>{
        this.name = event.target.value;
        this.onChange()
    }
    @action onEmailChage =(event)=>{
        this.email = event.target.value;
        this.onChange()
    }
    @action onPhoneChange =(event)=>{
        this.phone = event.target.value;
        this.onChange()
    }
    @action onMessageChange =(event)=>{
        this.message = event.target.value;
        this.onChange()
    }

    render(){

        return (

            <App  ui={this.ui} description={"We look forward to helping you create your own custom water feature.  Please call to set up a free, no obligation initial meeting."}>
                <Header ui={this.ui}>
                    <HeaderLeft ui={this.ui}></HeaderLeft>
                    <HeaderCenter></HeaderCenter>
                    <HeaderRight></HeaderRight>
                </Header>
                <PageMargins  small innerCls={Css.bodyContainer}>
                    <PageTitle title="Contact" subTitle="Let's Get Connected" addAnimation></PageTitle>

                    <div class={Css.contentContainer}>
                        <div class={Css.leftContainer}>
                            <div class={Css.detailContainer}>
                                <div>
                                    <Icons.Map_With_Pin class={Css.detailIcon}></Icons.Map_With_Pin>
                                </div>
                                <a  target="_blank" href="https://g.page/r/CRGlYq950AppEBA">
                                    <div class={Css.detailTitle}>Location / Service Area</div>
                                    <div class={Css.detailDesc}> {CompanyData.area} </div>
                                </a>
                            </div>
                            <div class={Css.detailContainer}>
                                <div>
                                    <Icons.Email class={Css.detailIcon}></Icons.Email>
                                </div>
                                <a href={"mailto: " + CompanyData.email}>
                                    <div class={Css.detailTitle}>Email</div>
                                    <div class={Css.detailDesc}>{CompanyData.email}</div>
                                </a>
                            </div>
                            <div class={Css.detailContainer}>
                                <div>
                                    <Icons.Phone class={Css.detailIcon}></Icons.Phone>
                                </div>
                                <a href={"tel:" + CompanyData.phoneNumber}>
                                    <div class={Css.detailTitle}>Phone</div>
                                    <div class={Css.detailDesc}>{CompanyData.phoneNumber}</div>
                                </a>
                            </div>
                            <div class={Css.detailContainer}>
                                <div>
                                    <FacebookIcon stroke color={C.primaryIconColor} class={Css.detailIcon}></FacebookIcon>
                                </div>
                                <a target="_blank" href={CompanyData.facebookUrl}>
                                    <div class={Css.detailTitle}>Facebook</div>
                                    <div class={Css.detailDesc}>{"@aquaticedge.ca"}</div>
                                </a>
                            </div>
                            <div class={Css.detailContainer}>
                                <div>
                                    <InstagramIcon stroke color={C.primaryIconColor} class={Css.detailIcon}></InstagramIcon>
                                </div>
                                <a target="_blank" href={CompanyData.instagramUrl}>
                                    <div class={Css.detailTitle}>Instagram</div>
                                    <div class={Css.detailDesc}>{"@aquaticedge.ca"}</div>
                                </a>
                            </div>
                        </div>
                        <div class={Css.rightContainer}>
                            <p>We're here to help and answer any questions you might have. Fill out the form below and we'll be in touch as soon as possible.</p>
                            <Options.Form onSubmit={this.submit}>
                                <Options.Row>
                                    <Options.Label default required>Name:</Options.Label>
                                    <Options.Name onChange={this.onNameChange} value={this.name} required ></Options.Name>
                                </Options.Row>
                                <Options.Row>
                                    <Options.Label default required>Email:</Options.Label>
                                    <Options.Email onChange={this.onEmailChage} value={this.email} required></Options.Email>
                                </Options.Row>
                                <Options.Row>
                                    <Options.Label>Phone:</Options.Label>
                                    <Options.Phone onChange={this.onPhoneChange} value={this.phone}></Options.Phone>
                                </Options.Row>
                                <Options.Row>
                                    <Options.Label required>Message:</Options.Label>
                                    <Options.TextArea onChange={this.onMessageChange} minLength={2} value={this.message} required></Options.TextArea>
                                </Options.Row>
                                {this.successMessage && <div class={Css.successMessage}>{this.successMessage}</div>}
                                {this.errorMessage && <div class={Css.errorMessage}>{this.errorMessage}</div>}
                                {
                                !this.sending ? <SolidBtn class={Css.submitBtn}>{this.sending ? "Sending..." : "Send"}</SolidBtn> :
                                    <div class={m(C.rowCenterEnd,C.m20)}>
                                        <Spinner></Spinner>
                                    </div>
                                    
                                }
                            </Options.Form>
                        </div>
                    </div>

                </PageMargins>
                <VerticalSpacer></VerticalSpacer>
                <Footer.View></Footer.View>
                <Sidepanel.View ui={this.ui}></Sidepanel.View>
            </App>

        )
    }
    
}